import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

interface IAddWorkerToInterventionSuccessAction {
  id: number;
  intervention_id?: number;
}

function addWorkerSuccess(
  draft: Draft<IInterventionData>,
  action: PayloadAction<IAddWorkerToInterventionSuccessAction>,
) {
  if (draft.getDetails.values) {
    draft.getDetails.values = {
      ...draft.getDetails.values,
      worker_ids: draft.getDetails.values?.worker_ids?.concat(
        action.payload.id,
      ),
    };
  }
}

export default addWorkerSuccess;
